<template>
  <RevDialog name="BOUYGUES_IN_STORE_CANCEL" :title="i18n(translations.title)">
    <template #body>
      <div class="body-1 flex flex-col gap-16">
        <p>{{ i18n(translations.paragraph1) }}</p>
        <p class="body-1-link">{{ i18n(translations.paragraph2title) }}</p>
        <p>{{ i18n(translations.paragraph2) }}</p>
      </div>
    </template>
    <template #trigger="{ open }">
      <div class="text-center">
        <RevLink class="text-action-default-low" @click="open">
          {{ i18n(translations.link) }}
        </RevLink>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDialog } from '@ds/components/Dialog'
import { RevLink } from '@ds/components/Link'

import translations from './CancelOrder.translations'

const i18n = useI18n()
</script>
